import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import SparkApi from "../api/SparkApi";
import InfoPill from "./InfoPill";
import { ToastContainer, toast } from "react-toastify";
import { DatatableWrapper, Filter, Pagination, PaginationOptions, TableBody, TableHeader } from "react-bs-datatable";
import { Link } from "react-router-dom";
import Confirm from "./Confirm";
import { usePermission } from "./context/PermissionContext";

const UserList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  // const [userInfo, setUserInfo] = useState();
  const [singleUserRec, setSingleUserRec] = useState({});
  const [deleleteUserRecord, setDeleteUserRecord] = useState(false);
  const [lead, setLead] = useState();
  const {userInfo} = usePermission();

  useEffect(() => {
    fetchAndSetUsers();
  }, []);

  async function fetchAndSetUsers() {
    try {
      const users = await SparkApi.fetchUsers();
      let resultWithoutSuperAdmin = users;

      if (userInfo.userrole === "ADMIN" || userInfo.userrole === "USER") {
        resultWithoutSuperAdmin = users.filter(
          (user) => user.userrole !== "SUPER_ADMIN"
        );
      }

      setBody(resultWithoutSuperAdmin);
      setLead(users || []);
    } catch (error) {
      setBody([]);
      setLead([]);
    }
  }

  const onFilterType = (event) => {
    if (event.target.value === "") {
      setBody(lead);
    } else {
      setBody(
        lead.filter((data) => {
          if (
            (data.leadstatus || "").toLowerCase() ===
            (event.target.value || "").toLowerCase()
          ) {
            return data;
          }
        })
      );
    }
  };

  const editUser = (row) => {
    navigate(`/users/${row.row.id}/e`, { state: row.row });
  };

  const header = [
    {
      title: "Name",
      prop: "username",
      isFilterable: true,
      cell: (row) => (
        <Link to={"/userview/" + row.id} state={row}>
          <span className="mx-2">{row.username}</span>
        </Link>
      ),
    },
    { title: "Role", prop: "userrole", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
    {
      title: "Active",
      prop: "isactive",
      isFilterable: true,
      cell: (row) =>
        row.isactive === true ? (
          <i
            class="fa-regular fa-square-check"
            style={{ fontSize: "1.3rem", marginLeft: "19px" }}
          ></i>
        ) : (
          <i
            class="fa-regular fa-square"
            style={{ fontSize: "1.3rem", marginLeft: "19px" }}
          ></i>
        ),
    },
    {
      title: "Actions",
      prop: "",
      cell: (row) => (
        <>
          <Button className="btn-sm" onClick={() => editUser({ row })}>
            <i className="fa-regular fa-pen-to-square "></i>
          </Button>
          <Button disabled={userInfo?.id === row.id} className="btn-sm mx-2" variant="danger" onClick={() => handleDelete(row)}>
            <i className="fa-regular fa-trash-can"></i>
          </Button>
        </>
      ),
    },
  ];

  const handleDeleteUser = async () => {
    try {
      const result = await SparkApi.deleteUser(singleUserRec.id);
      if (result.success) {
        setDeleteUserRecord(false);
        fetchAndSetUsers();
        return toast.success("User record deleted successfully");
      } else {
        return toast.error("Failed to delete User");
      }
    } catch (error) {
      console.error("Error deleting User:", error);
    }
  };

  const handleDelete = async (row) => {
    setDeleteUserRecord(true);
    setSingleUserRec(row);
  };

  const labels = {
    beforeSelect: " ",
  };

  const createUser = () => {
    navigate(`/users/e`);
  };

  return (
    <Container>
      <Row className="g-0">
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />

        <Col lg={12}>
          <DatatableWrapper
            body={body}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 10,
                options: [5, 10, 15, 20],
              },
            }}
          >
            <Row className="mb-4">
              <Col
                xs={12}
                lg={4}
                sm={4}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Filter />
              </Col>
              <Col
                xs={12}
                sm={6}
                lg={4}
                className="d-flex flex-col justify-content-start align-items-start"
              >
                <PaginationOptions labels={labels} />
                <div className="mt-2">
                  <InfoPill left="Total Users" right={body ? body.length : 0} />
                </div>
              </Col>
              <Col
                xs={12}
                sm={2}
                lg={4}
                className="d-flex flex-col justify-content-end align-items-end"
              >
                <Button
                  className="btn-sm"
                  variant="outline-primary mx-2"
                  onClick={() => createUser(true)}
                >
                  New User
                </Button>
              </Col>
            </Row>
            {body.length > 0 ? (
              <Table striped className="data-table" responsive>
                <TableHeader />
                <TableBody />
              </Table>
            ) : (
              <ShimmerTable row={10} col={8} />
            )}
            <Pagination />
          </DatatableWrapper>
        </Col>
        <Col lg={2}></Col>
        {deleleteUserRecord && (
          <Confirm
            show={deleleteUserRecord}
            handleCancel={() => setDeleteUserRecord(false)}
            onHide={() => setDeleteUserRecord(false)}
            handleDeleteUser={handleDeleteUser}
            title="Confirm delete?"
            message="You are going to delete the record. Are you sure?"
            table="userdelete"
          />
        )}
      </Row>
    </Container>
  );
};
export default UserList;
